import { createAction, props } from '@ngrx/store'

const SOURCE = '[Cadastral Area Search Component]'

export const resetCadastralAreaDefaultRoute = createAction(`${ SOURCE } ResetCadastralAreaDefaultRoute`)

export const resetItemCollection = createAction(`${ SOURCE } ResetItemCollection`)

export const resetFilterCriteria = createAction(`${ SOURCE } ResetFilterCriteria`)

export const resetCadastralAreaSearchKatuze = createAction(`${ SOURCE } ResetCadastralAreaSearchKatuze`)

export const resetCadastralAreaSearchRoute = createAction(`${ SOURCE } ResetCadastralAreaSearchRoute`)

export const setCadastralAreaDefaultRoute = createAction(
    `${ SOURCE } SetCadastralAreaDefaultRoute`,
    props<{route: string}>()
)

export const setCadastralAreaSearchRoute = createAction(
    `${ SOURCE } SetCadastralAreaSearchRoute`,
    props<{route: string}>()
)

export const setItemCollection = createAction(
    `${ SOURCE } SetItemCollection`,
    props<{itemCollection: any[]}>()
)

export const setFilterCriteria = createAction(
    `${ SOURCE } SetFilterCriteria`,
    props<{filterCriteria: any}>()
)

export const setFilterCriteriaProperty = createAction(
    `${ SOURCE } SetFilterCriteriaProperty`,
    props<{property: string; value: any}>()
)

export const updateFilterCriteria = createAction(
    `${ SOURCE } UpdateFilterCriteria`,
    props<{filterCriteriaFragment: any}>()
)

export const setCadastralAreaSearchKatuze = createAction(
    `${ SOURCE } SetCadastralAreaSearchKatuze`,
    props<{katuzeKod: string; katuzeNazev: string}>()
)

export const noAction = createAction(`${ SOURCE } No Action`)

// --- effects

export const filter = createAction(`${ SOURCE } Filter`)